import React from 'react'
import ConfiguratorImage from '../ConfiguratorImage'
import { normalizeX46MK2InteriorConfiguration } from './X46MK2RenderConfiguration'

export default function X46MK2InteriorConfiguratorImage (props) {
  return (
    <ConfiguratorImage
      {...props}
      configuration={normalizeX46MK2InteriorConfiguration(props.configuration)}
    />
  )
}



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2InteriorConfiguratorImage.js